<template>
    <span
        class="badge"
        :class="{
            'badge--danger': color === 'danger',
            'badge--primary': color === 'primary',
            'badge--success': color === 'success',
            'badge--warning': color === 'warning',
        }"
    >
        <slot />
    </span>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        color: {
            type: String,
            default: null,
        },
    },
}
</script>

<style lang="scss" scoped>
.badge {
    display: inline-block;
    padding: 4px 6px;
    background-color: $color-gray-light-new;
    border-radius: 6px;
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    transition: all 0.1s;

    &--danger {
        background-color: rgba($color-danger, 0.1);
        color: $color-danger;
    }

    &--primary {
        background-color: rgba($color-pill-blue, 0.1);
        color: $color-pill-blue;
    }

    &--success {
        background-color: rgba($color-success, 0.1);
        color: $color-success;
    }

    &--warning {
        background-color: rgba($color-orange, 0.1);
        color: $color-orange;
    }
}
</style>
